




























































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { loading, userPrefPageSize } from '@/decorators';
import { AxiosResponse } from 'axios';
import { yesNoStatus } from '@/enum';
import moment from 'moment';
import zip from '@/utils/zip';

@Component
export default class BillingListPage extends Vue {
  // 列表数据
  protected dataList: TypeFinance.BillingListItem[] = [];
  // 页码总数
  protected total: number = 0;
  // 表格列
  protected columns: TypeBase.TableColumn[] = [];

  protected loadingStatus: boolean = false;

  // 账户列表
  protected accountList: TypeFinance.AccountItem[] = [];
  /** 选中项 */
  protected selectedList: string[] = [];
  /** 是否选项 */
  protected yesNoStatus: TypeBase.EnumListItem[] = yesNoStatus;
  // 搜索项
  protected searchData: TypeFinance.BillingListParams = this.getInitSearchData();
  protected lastParams: TypeFinance.BillingListParams = {};
  // 获取初始搜索
  @userPrefPageSize('billingList')
  protected getInitSearchData(): TypeFinance.BillingListParams {
    return {
      bill_number: '',
      account_code: undefined,
      // begin_bill_to_time: '',
      // end_bill_to_time: '',
      is_overdue: undefined,
      timeArr: this.$util.getDefaultTimeCondition() as any,
      page_index: 1,
      page_size: 10,
    };
  }
  protected created(): void {
    const h = this.$createElement;
    this.columns = [
      {
        title: this.t('账单号'),
        dataIndex: 'bill_number',
        name: 'bill_number',
        filterEmpty: true,
        isCopy: true,
        width: 120,
      },
      {
        title: this.t('主体信息'),
        name: 'mainBody',
        width: 200,
        scopedSlots: { customRender: 'mainBody' },
      },
      {
        title: this.t('账单总金额'),
        align: 'right',
        name: 'allTotal',
        width: 120,
        scopedSlots: { customRender: 'allTotal' },
      },
      {
        title: this.t('期初余额'),
        align: 'right',
        width: 150,
        name: 'startBalance',
        scopedSlots: { customRender: 'startBalance' },
      },
      {
        title: this.t('期末余额'),
        align: 'right',
        width: 150,
        name: 'endBalance',
        scopedSlots: { customRender: 'endBalance' },
      },
      {
        title: this.t('返现金额'),
        width: 150,
        align: 'right',
        name: 'cashBackBalance',
        scopedSlots: { customRender: 'cashBackBalance' },
      },
      {
        title: <span class='important-label'>{this.t('已核销金额')}</span>,
        align: 'right',
        disabled: true,
        width: 150,
        name: 'verified_amount',
        scopedSlots: { customRender: 'verified_amount' },
      },
      {
        title: <span class='important-label'>{this.t('未核销金额')}</span>,
        align: 'right',
        disabled: true,
        width: 150,
        name: 'unverified_amount',
        scopedSlots: { customRender: 'unverified_amount' },
      },
      {
        label: this.t('逾期信息'),
        title: <div class='table-inside-cell important-label'>
          <div class='table-inside-row'>
            <div class='table-inside-td' style='justify-content: center'>{this.t('逾期信息')}</div>
          </div>
          <ul class='table-inside-row'>
            <li class='table-inside-td text-right' style='width: 150px;'>{this.t('逾期金额')}</li>
            <li class='table-inside-td text-right' style='width: 150px;'>{this.t('逾期天数')}</li>
          </ul>
        </div>,
        name: 'overdue_msg',
        width: 300,
        resetCellStyle: true,
        scopedSlots: {
          customRender: 'overdue_msg',
        },
        align: 'right',
      },
      {
        title: this.t('账单周期'),
        dataIndex: 'bill_period',
        name: 'bill_period',
        filterEmpty: true,
      },
      {
        title: this.t('账单出具时间'),
        dataIndex: 'bill_examine_time',
        name: 'bill_examine_time',
        filterEmpty: true,
      },
      {
        title: this.t('操作'),
        width: 80,
        fixed: 'right',
        showColumnSetting: true,
        scopedSlots: { customRender: 'operation' },
      },
    ];
    if (this.$route.query.isOverdue === String(this.$enum.common.Enabled.YES)) {
      this.searchData.is_overdue = this.$enum.common.Enabled.YES;
    }
    this.queryBillingList();
    this.queryAccountList();
  }
  // 账单列表
  @loading('loadingStatus')
  protected async queryBillingList(): Promise<void> {
    const postData = {};
    for (const key of Object.keys(this.searchData)) {
      if (!this.searchData[key] && this.searchData[key] !== 0) {
        continue;
      }
      if (key === 'timeArr' && this.searchData[key]!.length) {
        (postData as any).begin_bill_to_time = this.$util.formatDateTime((this.searchData[key] as any)[0]);
        (postData as any).end_bill_to_time = this.$util.formatDateTime((this.searchData[key] as any)[1]);
        continue;
      }
      postData[key] = this.searchData[key];
    }
    this.lastParams = this.$util.deepCopy(postData);
    const { data } = await this.$api.finance.queryBillingList<TypeBase.ListResult<TypeFinance.BillingListItem[]>>(postData);
    const { list = [], total = 0 } = data;
    this.dataList = list.map((item: TypeFinance.BillingListItem) => ({
      ...item,
      // start_balance_text: item.start_balance.balance + ' ' + item.start_balance.currency_code,
      // end_balance_text: item.end_balance.balance + ' ' + item.end_balance.currency_code,
      // cash_back_balance_text: item.cash_back_balance.balance + ' ' + item.cash_back_balance.currency_code,
      bill_period: item.bill_from_time + this.t('至') + item.bill_to_time,
    }));
    this.total = total;
  }
  // 页码变动
  protected handlePageChange(val: number): void {
    this.searchData.page_index = val;
    this.selectedList = [];
    this.queryBillingList();
  }
  // 搜索按钮
  protected handleSearch(): void {
    this.initPage();
    this.queryBillingList();
  }
  // 重置页面数据
  protected initPage(): void {
    this.selectedList.length = 0;
    this.searchData.page_index = 1;
  }
  // 清空
  protected handleReset(): void {
    this.searchData = this.getInitSearchData();
    this.queryBillingList();
  }
  // 获取账户列表
  protected async queryAccountList(): Promise<void> {
    const { data = [], code } = await this.$api.finance.queryAccountList();
    this.accountList = data.map((item: TypeFinance.AccountItem) => ({
      ...item,
      sign_business_list_text: item.sign_business_list.map((it: TypeFinance.SignBusinessItem) => it.key).join(','),
    }));
  }
  /**
   * 勾选切换
   */
  protected onSelectChange(selectedRowKeys: string[]): void {
    this.selectedList = selectedRowKeys;
  }
  /**
   * 下载账单数据
   */
  protected async downloadConfidential(param: TypeFinance.DownloadConfidential): Promise<void> {
    let filename: string = '';
    const res = await this.$api.finance.downloadConfidential(param, {
      responseCallback: (response: AxiosResponse) => {
        filename = this.$util.getResponseFilename(response.headers['content-disposition'] || '');
      },
    });
    if (!filename) {
      this.$message.error(this.t('响应数据错误，文件名称无法识别'));
      return;
    }
    this.$util.blobToFile(filename, res);
  }
  /**
   * @description:  下载账单statement
   * @param {*} postData
   * @return {*}
   */
  protected async downloadBillStatement(param: TypeFinance.DownloadStatementParam) {
    let filename: string = '';
    const res = await this.$api.finance.downloadBillStatement(param, {
      responseCallback: (response: AxiosResponse) => {
        filename = decodeURI(this.$util.getResponseFilename(response.headers['content-disposition'] || response.headers['Content-Disposition'] || '') || '');
      },
    });
    if (!filename) {
      this.$message.error(this.t('响应数据错误，文件名称无法识别'));
      return;
    }
    this.$util.blobToFile(filename, res);
  }
  /**
   * 下载或导出账单
   */
  protected handleDownloadFinance(code: string): void {
    this.downloadConfidential({
      doc_type: this.$enum.finance.DocType.BILLING_EXPORT,
      doc_number: code,
    });
  }
  /**
   * 导出
   */
  protected async handleExport(isAll: boolean): Promise<void> {
    let postData: TypeFinance.BillingExportParams = {};
    if (isAll) {
      postData = { ...this.lastParams };
      delete postData.page_index;
      delete postData.page_size;
      postData.bill_number_list = [];
    } else {
      if (!this.selectedList.length) {
        return this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip));
      }
      postData.bill_number_list = this.selectedList;
    }
    let filename: string = '';
    const res = await this.$api.finance.billingExport(postData, {
      responseCallback: (response: AxiosResponse) => {
        filename = decodeURI(this.$util.getResponseFilename(response.headers['content-disposition'] || response.headers['Content-Disposition'] || '') || '');
      },
    });
    if (!filename) {
      this.$message.error(this.t('响应数据错误，文件名称无法识别'));
      return;
    }
    this.$util.blobToFile(filename, res);
  }
  /**
   * @description: 下载打包statement
   * @param {*} record 列数据
   * @return {*}
   */
  protected handleDownloadStatement(record: TypeFinance.BillingListItem) {
    this.downloadBillStatement({
      list: record.statement_url_list,
    });
  }
  /**
   * 下载实报实销附件
   */
  protected handleDownloadSapFile(code: string): void {
    this.downloadConfidential({
      doc_type: this.$enum.finance.DocType.BILLING_CERTIFICATE_FILE,
      doc_number: code,
    });
  }
}
